<template lang="html">
  <div class="form-control" :class="classes">
    <div class="field-wrapper">
      <label class="form-label">{{ label }}</label>
      <Tooltip
        class="ml-5"
        v-if="tooltip"
        :tooltipText="tooltip"/>
      <div class="checkboxes is-block">
        <div class="checkbox is-switch">
          <input
            type="checkbox"
            :disabled="disabled"
            :name="name"
            :id="name"
            :checked="checked"
            v-on:change="$emit('change', $event.target.checked)">
          <label :for="name">{{getSelectedOption}}</label>
          <span class="error-information" v-for="(error, index) in errors" :key="index">
            {{ error }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Tooltip from '@/components/Tooltip.vue';

export default {
  name: 'VqToggleBtn',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    tooltip: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    checked: Boolean,
    label: String,
    classes: String,
    optionTrue: {
      type: String,
      default: 'Vrai',
    },
    optionFalse: {
      type: String,
      default: 'Faux',
    },
    name: String,
    errors: {
      type: Array,
      default() { return []; },
    },
  },
  components: {
    Tooltip,
  },
  computed: {
    getSelectedOption() {
      return this.checked ? this.optionTrue : this.optionFalse;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
